import { useEffect, useRef } from 'react';
export function InlineFeedback({ id, children, variant = 'error', onRetry, focus = false, className = '' }) {
  const ref = useRef(null);
  useEffect(() => { if (focus && children) ref.current?.focus(); }, [focus, children]);
  if (!children) return null;
  return <div id={id} ref={ref} tabIndex={focus ? -1 : undefined} role={variant === 'error' ? 'alert' : 'status'}
    className={`rounded border p-3 text-sm ${variant === 'error' ? 'border-red-200 bg-red-50 text-red-800' : 'border-slate-200 bg-slate-50 text-slate-700'} ${className}`}>
    {children}{onRetry && <button type="button" className="ml-3 underline" onClick={onRetry}>Retry</button>}
  </div>;
}
